/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react"
import qs from "query-string"
import _ from "lodash"
import styled from "styled-components"
import {
  faArrowDownShortWide,
  faLink,
  faSearch,
  faTimes,
  faPlus,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useUpdateInboxHeader } from "../../hooks/useUpdateInboxHeader"
import theme from "../../stylesheets/theme"
import { ModalBody } from "../../components/Radiate/ThemedModal/ThemedModal"

const INBOX_URL = process.env.REACT_APP_INBOX_URL
const SERVER_API_PATH_GROUP = process.env.REACT_APP_SERVER_GROUP_API_PATH

const SPACING = "8px"
const LARGE_SPACING = "16px"
const AVATAR_SIZE = "60px"
const GROUP_INFO_HEADER_HEIGHT = "90px"
const PHONE_INPUT_WIDTH = "60%"
const COUNTRY_CODE_WIDTH = "40%"

const DANGER_TEXT = "#ef4444"

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

const AvatarSection = styled.div`
  flex: 0 0 ${AVATAR_SIZE};
  cursor: not-allowed;
`

const GroupDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

const AvatarPlaceholder = styled.div`
  width: ${AVATAR_SIZE};
  height: ${AVATAR_SIZE};
  border-radius: 50%;
  background-color: ${theme.gray2};
  display: flex;
  align-items: center;
  justify-content: center;
`

const IconWrapper = styled.div`
  color: white;
  font-size: 24px;
`

const GroupInfoWrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-height: ${GROUP_INFO_HEADER_HEIGHT};
  overflow: auto;
  padding: ${SPACING};
  border-radius: ${SPACING};
  gap: ${SPACING};
`

const MarginWrapper = styled.div`
  margin: ${SPACING};
`

export const ActionBar = styled.div`
  box-sizing: border-box;
  border-top: 1px solid ${theme.gray1};
  padding: 8px 12px;
  display: flex;
  justify-content: ${(p) => (p.hasErrors ? "space-between" : "flex-end")};
  align-items: center;
  justify-self: flex-end;

  .box-button-container {
    margin-left: 8px;
  }
`

export const PhoneFieldGroup = styled.div`
  display: flex;
  gap: ${SPACING};
  align-items: flex-start;
`

export const CountryCodeWrapper = styled.div`
  width: ${COUNTRY_CODE_WIDTH};
`

export const PhoneWrapper = styled.div`
  width: ${PHONE_INPUT_WIDTH};
`

const ErrorMessage = styled.div`
  color: ${DANGER_TEXT};
  font-size: 0.75rem;
  margin-top: 4px;
  margin-left: 4px;
`

const ModalTitle = styled.h2`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${theme.gray12};
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${theme.gray6};
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: ${theme.gray1};
    color: ${theme.gray8};
  }
`

const SearchSection = styled.div`
  margin-bottom: 12px;
  flex-shrink: 0;
`

const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
`

const SearchInput = styled.input`
  width: 100%;
  padding: 10px 14px 10px 36px;
  border: 1px solid ${theme.gray1};
  border-radius: 6px;
  font-size: 13px;
  background: ${theme.white};
  
  &:focus {
    outline: none;
    border-color: ${theme.primary};
    box-shadow: 0 0 0 1px ${theme.primary};
  }
  
  &::placeholder {
    color: ${theme.gray5};
  }
`

const SearchIcon = styled(FontAwesomeIcon)`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: ${theme.gray5};
  font-size: 13px;
`

const ClearSearchButton = styled.button`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: ${theme.gray5};
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: ${theme.gray1};
    color: ${theme.gray8};
  }
`

const ContactsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`

const ContactsCount = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: ${theme.black};

`

const SortButton = styled.button`
  background: none;
  border: none;
  color: ${theme.black};
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  position: relative;
  font-weight: bold;

  &:hover {
    background: ${theme.gray1};
    color: ${theme.gray8};
  }
`

const SortDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: ${theme.white};
  border: 1px solid ${theme.gray1};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 180px;
  padding: 4px 0;
  margin-top: 2px;
`

const SortOption = styled.div`
  padding: 8px 12px;
  font-size: 12px;
  color: ${theme.gray8};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.2s ease;
  
  &:hover {
    background: ${theme.gray0};
  }
  
  ${(props) => props.selected && `
    background: ${theme.themeColorLightFocus};
    color: ${theme.primary};
  `}
`

const RadioButton = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid ${(props) => (props.checked ? theme.primary : theme.gray3)};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  position: relative;
  
  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${theme.primary};
    opacity: ${(props) => (props.checked ? 1 : 0)};
    transition: opacity 0.2s ease;
  }
`

const ContactsList = styled.div`
  background: ${theme.white};
  border: 1px solid ${theme.gray1};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
`

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-bottom: 1px solid ${theme.gray1};
  cursor: pointer;
  transition: background-color 0.2s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: ${theme.gray0};
  }
  
  ${(props) => props.selected && `
    background: ${theme.themeColorLightFocus};
    border-color: ${theme.primary};
  `}
`

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`

const ContactAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${theme.gray2};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.gray6};
  font-size: 12px;
  flex-shrink: 0;
`

const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  gap: 4px;
  overflow: hidden;
`

const ContactName = styled.div`
  font-weight: 500;
  color: ${theme.gray12};
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const ContactPhone = styled.div`
  font-size: 14px;
  color: ${theme.gray6};
  word-break: break-all;
  overflow-wrap: break-word;
  line-height: 1.3;
  max-width: 100%;
`

const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  cursor: pointer;
  accent-color: ${theme.primary};
`

const InviteLinkSection = styled.div`
  margin-top: 8px;
  padding: 8px 12px;
  flex-shrink: 0;
  background: ${theme.white};
`

const InviteLinkTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: ${theme.gray12};
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`

const InviteLinkContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${theme.white};
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid ${theme.gray1};
`

const InviteLinkText = styled.a`
  font-size: 14px;
  color: ${theme.primary};
  text-decoration: none;
  cursor: pointer;
  margin-right: 8px;
  display: inline;
  word-break: break-all;
  overflow-wrap: break-word;
  
  &:hover {
    text-decoration: underline;
    color: ${theme.primary};
  }
`

const CopyButton = styled.button`
  background: none;
  border: none;
  color: ${theme.gray6};
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: ${theme.gray1};
    color: ${theme.primary};
  }
`

const InviteLinkNote = styled.div`
  font-size: 14px;
  color: ${theme.black};
  margin-top: 8px;
  line-height: 1.4;
  word-break: break-word;
  font-style: italic;
`

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid ${theme.gray1};
  background: ${theme.gray0};
  margin-top: auto;
`

const StyledActionButton = styled.button`
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s ease;
  
  ${(props) => props.primary && `
    background: #0000FF;
    color: ${theme.white};
  
  `}
  
  ${(props) => props.secondary && `
    background: #0000FF;
    color: ${theme.white};
    border: 1px solid ${theme.gray2};
  `}
  
  &:active {
    transform: translateY(0);
    box-shadow: none;
  }
  
  &:disabled {
    background: ${theme.gray3};
    color: ${theme.gray5};
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`

const SelectedContactsSection = styled.div`
  margin-bottom: 12px;
  padding: 6px;
  background: #EBF3FF;
  border-radius: 6px;
  border: 1px solid ${theme.gray1};
  min-height: 40px;
  max-height: 100px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
`

const SelectedContactsHeader = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${theme.gray8};
  margin-bottom: 4px;
`

const SelectedContactsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: flex-start;
  overflow-y: auto;
  max-height: 60px;
  padding-right: 4px; /* Add some padding for the scrollbar */
  
  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${theme.gray3};
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${theme.gray4};
  }
  
  /* Firefox scrollbar */
  scrollbar-width: thin;
  scrollbar-color: ${theme.gray3} transparent;
`

const SelectedContactTag = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${theme.white};
  border: 1px solid ${theme.gray2};
  border-radius: 16px;
  padding: 4px 8px;
  font-size: 12px;
  color: ${theme.gray12};
  max-width: 150px;
`

const SelectedContactName = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`

const RemoveContactButton = styled.button`
  background: none;
  border: none;
  color: ${theme.gray5};
  cursor: pointer;
  padding: 2px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  
  &:hover {
    background: ${theme.gray1};
    color: ${theme.gray8};
  }
`

const LoadMoreButton = styled.button`
  width: 100%;
  padding: 12px;
  background: none;
  border: none;
  color: ${theme.primary};
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  border-top: 1px solid ${theme.gray1};
  transition: background-color 0.2s ease;
  
  &:hover:not(:disabled) {
    background: ${theme.gray0};
  }
  
  &:disabled {
    color: ${theme.gray5};
    cursor: not-allowed;
  }
`

const LoadingIndicator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  color: ${theme.gray6};
  font-size: 13px;
`

const SkeletonContainer = styled.div`
  padding: 8px 10px;
  border-bottom: 1px solid ${theme.gray1};
  
  &:last-child {
    border-bottom: none;
  }
`

const SkeletonContactItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`

const SkeletonContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`

const SkeletonAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(90deg, ${theme.gray1} 25%, ${theme.gray0} 50%, ${theme.gray1} 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`

const SkeletonText = styled.div`
  background: linear-gradient(90deg, ${theme.gray1} 25%, ${theme.gray0} 50%, ${theme.gray1} 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`

const SkeletonName = styled(SkeletonText)`
  height: 14px;
  width: ${(props) => props.width || "120px"};
  margin-bottom: 4px;
`

const SkeletonPhone = styled(SkeletonText)`
  height: 12px;
  width: ${(props) => props.width || "100px"};
`

const SkeletonCheckbox = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  background: linear-gradient(90deg, ${theme.gray1} 25%, ${theme.gray0} 50%, ${theme.gray1} 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  
  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`

const SkeletonContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  gap: 4px;
`

const NoSelectionText = styled.div`
  font-size: 12px;
  color: ${theme.gray5};
  font-style: italic;
`

const LimitErrorText = styled.div`
  font-size: 12px;
  color: #ef4444;
  font-weight: 500;
  margin-top: 4px;
  padding: 4px 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 4px;
  text-align: center;
`

const AddContactButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 10px;
  border-bottom: 1px solid ${theme.gray1};
  cursor: pointer;
  transition: background-color 0.2s ease;
  background: ${theme.themeColorLightFocus};
  border: 1px solid ${theme.primary};
  border-radius: 6px;
  margin: 8px;
  
  &:hover {
    background: ${theme.themeColorFocus};
  }
`

const AddContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`

const AddContactIcon = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.white};
  font-size: 14px;
  flex-shrink: 0;
`

const AddContactText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`

const AddContactLabel = styled.div`
  font-weight: 500;
  color: ${theme.primary};
  font-size: 13px;
`

const AddContactSubtext = styled.div`
  font-size: 12px;
  color: ${theme.gray6};
`

const Tooltip = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: ${theme.gray12};
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 9999;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  transition: opacity 0.2s ease, visibility 0.2s ease;
  margin-top: 5px;
  
  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-bottom-color: ${theme.gray12};
  }
`

// eslint-disable-next-line no-unused-vars
const AddMembers = ({ location }) => {
  // Parse URL parameters from iframe
  const query = qs.parse(location?.search || window.location.search)
  const {
    groupInviteLink,
    ctx,
  } = query

  const [signedContext, setSignedContext] = useState()
  const [payload, setPayload] = useState()
  const [currentContextToken, setCurrentContextToken] = useState(ctx)
  const [subject, setSubject] = useState("")
  const [description, setDescription] = useState("")
  const [errors, setErrors] = useState({})
  const [searchQuery, setSearchQuery] = useState("")
  const [selectedContacts, setSelectedContacts] = useState([])
  const [selectedContactsData, setSelectedContactsData] = useState([]) // Cache for selected contacts data
  const [sortOrder, setSortOrder] = useState("newer") // Changed to match available sort options
  const [showSortDropdown, setShowSortDropdown] = useState(false)
  const [contacts, setContacts] = useState([])
  const [loading, setLoading] = useState(false)
  const [showLimitError, setShowLimitError] = useState(false) // New state for limit error
  const [tooltipVisible, setTooltipVisible] = useState(false)
  const [copyTooltipVisible, setCopyTooltipVisible] = useState(false)
  const [pageInfo, setPageInfo] = useState({
    hasNextPage: false,
    hasPreviousPage: false,
    endCursor: null,
  })

  // Helper function to show limit error
  const triggerLimitError = () => {
    setShowLimitError(true)
    // Hide error after 5 seconds
    setTimeout(() => {
      setShowLimitError(false)
    }, 5000)
  }

  // console.log("AddMembers received params:", {
  //   ctx, payload, signedContext,
  // })

  // Render skeleton loading items
  const renderSkeletonItems = (count = 5) => {
    const widths = ["140px", "180px", "110px", "160px", "130px"]
    const phoneWidths = ["90px", "110px", "95px", "105px", "100px"]
    return Array.from({ length: count }, (item, index) => (
      <SkeletonContainer key={`skeleton-${index}`}>
        <SkeletonContactItem>
          <SkeletonContactInfo>
            <SkeletonAvatar />
            <SkeletonContactDetails>
              <SkeletonName width={widths[index % widths.length]} />
              <SkeletonPhone width={phoneWidths[index % phoneWidths.length]} />
            </SkeletonContactDetails>
          </SkeletonContactInfo>
          <SkeletonCheckbox />
        </SkeletonContactItem>
      </SkeletonContainer>
    ))
  }

  // Utility function to check if a string looks like a phone number
  const isPhoneNumber = (str) => {
    if (!str || str.trim().length === 0) return false
    // Remove all non-digit characters except + at the beginning
    const cleaned = str.replace(/[^\d+]/g, "")
    // Check if it's purely numeric (with optional + at start) and has reasonable length
    const phoneRegex = /^\+?\d{7,15}$/
    return phoneRegex.test(cleaned) && cleaned.length >= 7
  }

  // Function to create a new contact from phone number
  const createContactFromPhone = (phoneNumber) => {
    const cleanedPhone = phoneNumber.trim()
    const displayName = cleanedPhone

    const newContact = {
      id: cleanedPhone, // Use phone number as ID
      name: displayName, // Use phone number as name initially
      phone: cleanedPhone,
      avatar: null,
      dateAdded: new Date(),
      isManuallyAdded: true, // Flag to identify manually added contacts
    }
    return newContact
  }

  // Function to add phone number as new contact
  const addPhoneAsContact = (phoneNumber) => {
    // Check if we've reached the limit before adding
    if (selectedContacts.length >= 8) {
      triggerLimitError()
      return
    }

    const newContact = createContactFromPhone(phoneNumber)

    // Check if contact already exists
    const existingContact = contacts.find((contact) => contact.phone === newContact.phone || contact.id === newContact.id)
    if (!existingContact) {
      setContacts((prev) => [newContact, ...prev])
      // Automatically select the new contact and cache its data only if under the limit
      setSelectedContacts((prev) => {
        if (prev.length >= 8) {
          return prev // Don't add if we've reached the limit
        }
        setSelectedContactsData((prevData) => [...prevData, newContact])
        return [...prev, newContact.id]
      })
    } else {
      // If exists, just select it (only if under the limit)
      setSelectedContacts((prev) => {
        if (!prev.includes(existingContact.id) && prev.length < 8) {
          // Add to cache if not already cached
          setSelectedContactsData((prevData) => {
            const alreadyCached = prevData.find((contact) => contact.id === existingContact.id)
            if (!alreadyCached) {
              return [...prevData, existingContact]
            }
            return prevData
          })
          return [...prev, existingContact.id]
        }
        if (prev.length >= 8 && !prev.includes(existingContact.id)) {
          // Show error if trying to add when limit is reached
          triggerLimitError()
        }
        return prev
      })
    }

    // Clear search to show the added contact - use setTimeout to prevent immediate refetch
    setTimeout(() => {
      setSearchQuery("")
    }, 100)
  }

  // Transform API response to our contact format
  const transformApiContact = (apiContact) => {
    const { node } = apiContact
    // Skip contacts with GROUP- prefix in externalId (these are group identifiers, not regular contacts)
    if (node.externalId && node.externalId.startsWith("GROUP-")) {
      return null
    }

    const fullName = [node.firstName, node.lastName].filter(Boolean).join(" ") || "Unknown"
    const displayPhone = node.externalId || ""

    return {
      id: node._id,
      name: fullName,
      phone: displayPhone,
      avatar: null,
      dateAdded: new Date(node.createdAt),
    }
  }

  // Mock contacts data - fallback when API is not available
  const getMockContacts = () => {
    const mockData = [
      {
        node: {
          _id: "68b8908ba05bee0b6de1ff77",
          firstName: "Servicio profesional",
          lastName: null,
          externalId: "299113012",
          gender: "female",
          locale: "es_ES",
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091617,
          createdAt: 1756926091565,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmY3Nw==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1ff25",
          firstName: "Testealo",
          lastName: null,
          externalId: "299113020",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091546,
          createdAt: 1756926091539,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmYyNQ==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fed6",
          firstName: "(Test Eliana)",
          lastName: null,
          externalId: "29911300",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091559,
          createdAt: 1756926091513,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmVkNg==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fe8c",
          firstName: "CCCCC",
          lastName: null,
          externalId: "2991130445",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091506,
          createdAt: 1756926091499,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmU4Yw==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fe64",
          firstName: "Group Api Test 27 Aug",
          lastName: null,
          externalId: "2991130220",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091493,
          createdAt: 1756926091486,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmU2NA==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fdc3",
          firstName: "Gime Group test",
          lastName: null,
          externalId: "29911302",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091642,
          createdAt: 1756926091446,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmRjMw==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fd72",
          firstName: "Hello Group Api",
          lastName: null,
          externalId: "299113022",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091439,
          createdAt: 1756926091432,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmQ3Mg==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fcf8",
          firstName: "Alif Sakib",
          lastName: null,
          externalId: "2991130540",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091412,
          createdAt: 1756926091405,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmNmOA==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fcb8",
          firstName: "dfghjk",
          lastName: null,
          externalId: "2991130",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091629,
          createdAt: 1756926091391,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmNiOA==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fc8f",
          firstName: "TEST STAGING",
          lastName: null,
          externalId: "299113030",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091385,
          createdAt: 1756926091379,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmM4Zg==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fc62",
          firstName: "TEST STAGING",
          lastName: null,
          externalId: "299113054",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091372,
          createdAt: 1756926091366,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmM2Mg==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fc18",
          firstName: "TEST STAGING",
          lastName: null,
          externalId: "29911303",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091360,
          createdAt: 1756926091352,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmMxOA==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fba8",
          firstName: "TEST STAGING",
          lastName: null,
          externalId: "29911301",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091346,
          createdAt: 1756926091339,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmJhOA==",
        },
      },
      {
        node: {
          _id: "68b8908ba05bee0b6de1fb50",
          firstName: "Group Api 1",
          lastName: null,
          externalId: "299113005",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
            "reachable",
          ],
          updatedAt: 1756926091425,
          createdAt: 1756926091296,
          id: "bWVtYmVyOjY4Yjg5MDhiYTA1YmVlMGI2ZGUxZmI1MA==",
        },
      },
      {
        node: {
          _id: "68b6fe0ea8a6b77083ce40b3",
          firstName: "Gime Group test",
          lastName: null,
          externalId: "GROUP-Y2FwaV9ncm91cDoxNTU1NjAwMzk3NjoxMjAzNjM0MjAzOTc2NzkwNTIZD",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
          ],
          updatedAt: 1757062619462,
          createdAt: 1756823054376,
          id: "bWVtYmVyOjY4YjZmZTBlYThhNmI3NzA4M2NlNDBiMw==",
        },
      },
      {
        node: {
          _id: "68b6da32a8a6b77083ce407f",
          firstName: null,
          lastName: null,
          externalId: "Y2FwaV9ncm91cDoxNTU1NjAwMzk3NjoxMjAzNjM0MDQxODgzMjcwMjgZD",
          gender: null,
          locale: null,
          tags: [],
          updatedAt: 1756964274255,
          createdAt: 1756813874486,
          id: "bWVtYmVyOjY4YjZkYTMyYThhNmI3NzA4M2NlNDA3Zg==",
        },
      },
      {
        node: {
          _id: "68b6d9dba8a6b77083ce4074",
          firstName: null,
          lastName: null,
          externalId: "GROUP-Y2FwaV9ncm91cDoxNTU1NjAwMzk3NjoxMjAzNjM0MjQyMDI1Njk2MzYZD",
          gender: null,
          locale: null,
          tags: [],
          updatedAt: 1757063433104,
          createdAt: 1756813787795,
          id: "bWVtYmVyOjY4YjZkOWRiYThhNmI3NzA4M2NlNDA3NA==",
        },
      },
      {
        node: {
          _id: "68b6d9a9a8a6b77083ce406c",
          firstName: null,
          lastName: null,
          externalId: "34647181380",
          gender: null,
          locale: null,
          tags: [
            "reachable",
          ],
          updatedAt: 1756926091602,
          createdAt: 1756813737065,
          id: "bWVtYmVyOjY4YjZkOWE5YThhNmI3NzA4M2NlNDA2Yw==",
        },
      },
      {
        node: {
          _id: "68b6d993a8a6b77083ce406a",
          firstName: "dfghjk",
          lastName: null,
          externalId: "GROUP-Y2FwaV9ncm91cDoxNTU1NjAwMzk3NjoxMjAzNjM0MDQxODgzMjcwMjgZD",
          gender: null,
          locale: null,
          tags: [
            "WHATSAPP-GROUP",
          ],
          updatedAt: 1756964274323,
          createdAt: 1756813715177,
          id: "bWVtYmVyOjY4YjZkOTkzYThhNmI3NzA4M2NlNDA2YQ==",
        },
      },
      {
        node: {
          _id: "68b6d72ba8a6b77083ce4040",
          firstName: "Servicio profesional",
          lastName: null,
          externalId: "GROUP-Y2FwaV9ncm91cDoxNTU1NjAwMzk3NjoxMjAzNjM0MjQyMDI1Njk2MzYZD",
          gender: "female",
          locale: "es_ES",
          tags: [
            "WHATSAPP-GROUP",
          ],
          updatedAt: 1757063433013,
          createdAt: 1756813099471,
          id: "bWVtYmVyOjY4YjZkNzJiYThhNmI3NzA4M2NlNDA0MA==",
        },
      },
    ]
    return mockData.map(transformApiContact).filter((contact) => contact !== null)
  }

  // Fetch contacts from API
  const fetchContacts = async (cursor = null, size = 20, filterQuery = "") => {
    // Skip API calls during react-snap crawling
    if (navigator.userAgent === "ReactSnap") {
      console.log("Skipping API call during react-snap crawling")
      return
    }
    setLoading(true)
    try {
      let url = `${SERVER_API_PATH_GROUP}/group/members?size=${size}`
      if (cursor) {
        url += `&after=${cursor}`
      }
      // Add search parameter based on query type
      if (filterQuery && filterQuery.trim()) {
        const trimmedQuery = filterQuery.trim()
        // Check if query contains only digits (phone number search)
        if (/^\d+$/.test(trimmedQuery)) {
          url += `&search=${encodeURIComponent(trimmedQuery)}`
        } else {
          // Query contains any letters/text (name search)
          url += `&firstName=${encodeURIComponent(trimmedQuery)}`
        }
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Woztell-Context": currentContextToken || "",
          // "X-Woztell-Payload": JSON.stringify(payload) || "",
          // "X-Woztell-SignedContext": signedContext || "",
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()

      if (data.ok === 1 && data.edges) {
        // logging the API response for debugging
        // console.log("API response ADDMEMBER:", data)
        const transformedContacts = data.edges.map(transformApiContact).filter((contact) => contact !== null)
        // Preserve manually added contacts when updating from API
        setContacts((prevContacts) => {
          const manuallyAdded = prevContacts.filter((contact) => contact.isManuallyAdded)
          const apiContacts = transformedContacts.filter((contact) => !manuallyAdded.some((manual) => manual.id === contact.id || manual.phone === contact.phone))
          return [...manuallyAdded, ...apiContacts]
        })

        // Update selected contacts cache with any found contacts from API
        if (selectedContacts.length > 0) {
          const selectedFromApi = transformedContacts.filter((contact) => selectedContacts.includes(contact.id))
          if (selectedFromApi.length > 0) {
            setSelectedContactsData((prevCache) => {
              const updatedCache = [...prevCache]
              selectedFromApi.forEach((contact) => {
                const existingIndex = updatedCache.findIndex((c) => c.id === contact.id)
                if (existingIndex >= 0) {
                  // Update existing cached contact with fresh data
                  updatedCache[existingIndex] = contact
                } else {
                  // Add to cache if not present
                  updatedCache.push(contact)
                }
              })
              return updatedCache
            })
          }
        }

        setPageInfo(data.pageInfo)
      } else {
        throw new Error("Invalid API response format")
      }
    } catch (error) {
      // console.warn("API call failed, using mock data:", error.message)
      // Fallback to mock data when API fails, but preserve manually added contacts
      setContacts((prevContacts) => {
        const manuallyAdded = prevContacts.filter((contact) => contact.isManuallyAdded)
        const mockContacts = getMockContacts().filter((contact) => !manuallyAdded.some((manual) => manual.id === contact.id || manual.phone === contact.phone))
        return [...manuallyAdded, ...mockContacts]
      })

      // Update selected contacts cache with any found contacts from mock data
      if (selectedContacts.length > 0) {
        const selectedFromMock = getMockContacts().filter((contact) => selectedContacts.includes(contact.id))
        if (selectedFromMock.length > 0) {
          setSelectedContactsData((prevCache) => {
            const updatedCache = [...prevCache]
            selectedFromMock.forEach((contact) => {
              const existingIndex = updatedCache.findIndex((c) => c.id === contact.id)
              if (existingIndex >= 0) {
                // Update existing cached contact with fresh data
                updatedCache[existingIndex] = contact
              } else {
                // Add to cache if not present
                updatedCache.push(contact)
              }
            })
            return updatedCache
          })
        }
      }

      setPageInfo({
        hasNextPage: false,
        hasPreviousPage: false,
        endCursor: null,
      })
    } finally {
      setLoading(false)
    }
  }

  // Load more contacts (pagination)
  const loadMoreContacts = async () => {
    if (!pageInfo.hasNextPage || loading) return

    try {
      setLoading(true)
      let url = `${SERVER_API_PATH_GROUP}/group/members?size=20`
      if (pageInfo.endCursor) {
        url += `&after=${pageInfo.endCursor}`
      }

      // Add search parameter for load more based on query type
      if (searchQuery && searchQuery.trim()) {
        const trimmedQuery = searchQuery.trim()
        // Check if query contains only digits (phone number search)
        if (/^\d+$/.test(trimmedQuery)) {
          url += `&search=${encodeURIComponent(trimmedQuery)}`
        } else {
          // Query contains any letters/text (name search)
          url += `&firstName=${encodeURIComponent(trimmedQuery)}`
        }
      }

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-Woztell-Context": currentContextToken || "",
          "X-Woztell-Payload": JSON.stringify(payload) || "",
          "X-Woztell-SignedContext": signedContext || "",
        },
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      if (data.ok === 1 && data.edges) {
        const transformedContacts = data.edges.map(transformApiContact).filter((contact) => contact !== null)
        setContacts((prev) => [...prev, ...transformedContacts])

        // Update selected contacts cache with any found contacts from API
        if (selectedContacts.length > 0) {
          const selectedFromApi = transformedContacts.filter((contact) => selectedContacts.includes(contact.id))
          if (selectedFromApi.length > 0) {
            setSelectedContactsData((prevCache) => {
              const updatedCache = [...prevCache]
              selectedFromApi.forEach((contact) => {
                const existingIndex = updatedCache.findIndex((c) => c.id === contact.id)
                if (existingIndex >= 0) {
                  // Update existing cached contact with fresh data
                  updatedCache[existingIndex] = contact
                } else {
                  // Add to cache if not present
                  updatedCache.push(contact)
                }
              })
              return updatedCache
            })
          }
        }

        setPageInfo(data.pageInfo)
      }
    } catch (error) {
      console.error("Failed to load more contacts:", error.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // Skip API calls during react-snap crawling
    if (navigator.userAgent === "ReactSnap") {
      return
    }
    // Debounce search to avoid making too many API calls
    const timeoutId = setTimeout(() => {
      fetchContacts(null, 20, searchQuery)
    }, 300) // 300ms delay

    return () => clearTimeout(timeoutId)
  }, [searchQuery, currentContextToken, signedContext, JSON.stringify(payload)])

  const sortOptions = [
    // { value: "name-asc", label: "Sort by name A-Z" },
    // { value: "name-desc", label: "Sort by name Z-A" },
    // { value: "number-asc", label: "Sort by number 1-9" },
    // { value: "number-desc", label: "Sort by number 9-1" },
    { value: "newer", label: "Sort by newer" },
    { value: "older", label: "Sort by older" },
  ]

  const getCurrentSortLabel = () => {
    const currentOption = sortOptions.find((option) => option.value === sortOrder)
    return currentOption ? currentOption.label : "Sort by newer"
  }

  const handleSortChange = (newSortOrder) => {
    setSortOrder(newSortOrder)
    setShowSortDropdown(false)
  }

  const handleSortToggle = () => {
    setShowSortDropdown(!showSortDropdown)
  }

  // Since we're doing server-side filtering, we don't need client-side filtering anymore
  const filteredContacts = contacts

  const sortedContacts = [...filteredContacts].sort((a, b) => {
    switch (sortOrder) {
      case "name-asc":
        return a.name.localeCompare(b.name)
      case "name-desc":
        return b.name.localeCompare(a.name)
      case "number-asc":
        return a.phone.localeCompare(b.phone)
      case "number-desc":
        return b.phone.localeCompare(a.phone)
      case "newer":
        return new Date(b.dateAdded) - new Date(a.dateAdded)
      case "older":
        return new Date(a.dateAdded) - new Date(b.dateAdded)
      default:
        return a.name.localeCompare(b.name)
    }
  })

  const handleContactToggle = (contactId) => {
    const contact = contacts.find((c) => c.id === contactId)
    // console.log("handleContactToggle called, current selected count:", selectedContacts.length)

    setSelectedContacts((prev) => {
      // console.log("Inside setSelectedContacts, prev length:", prev.length)
      if (prev.includes(contactId)) {
        // Remove from selected contacts and cache
        setSelectedContactsData((prevData) => prevData.filter((c) => c.id !== contactId))
        return prev.filter((id) => id !== contactId)
      }

      // Check if we've reached the 8-member limit before adding
      if (prev.length >= 8) {
        // Show error notification
        // console.log("Reached 8-member limit, calling triggerLimitError")
        triggerLimitError()
        return prev // Don't add more contacts if we've reached the limit
      }

      // Add to selected contacts and cache
      if (contact) {
        setSelectedContactsData((prevData) => {
          const alreadyCached = prevData.find((c) => c.id === contactId)
          if (!alreadyCached) {
            return [...prevData, contact]
          }
          return prevData
        })
      }
      return [...prev, contactId]
    })
  }

  const handleRemoveContact = (contactId) => {
    setSelectedContacts((prev) => prev.filter((id) => id !== contactId))
    setSelectedContactsData((prev) => prev.filter((contact) => contact.id !== contactId))
    // Clear error when removing contacts
    setShowLimitError(false)
  }

  const getSelectedContactsData = () => {
    // First try to get from cache
    const cachedContacts = selectedContactsData.filter((contact) => selectedContacts.includes(contact.id))

    // For any missing contacts from cache, try to find them in current contacts array
    const missingContactIds = selectedContacts.filter((id) => !cachedContacts.find((contact) => contact.id === id))
    const missingContacts = missingContactIds.map((id) => contacts.find((contact) => contact.id === id)).filter(Boolean)

    // Update cache with missing contacts
    if (missingContacts.length > 0) {
      setSelectedContactsData((prev) => {
        const newData = [...prev]
        missingContacts.forEach((contact) => {
          if (!newData.find((c) => c.id === contact.id)) {
            newData.push(contact)
          }
        })
        return newData
      })
    }

    return [...cachedContacts, ...missingContacts]
  }

  const receiveMessage = (event) => {
    const whitelistedOrigins = INBOX_URL.split("||")
    if (!whitelistedOrigins.includes(event.origin)) {
      return
    }
    if (event?.data) {
      // console.log("Event Data", event.data)

      if (!_.isEmpty(event.data?.payload)) {
        setPayload(event.data?.payload)
        setSignedContext(event.data?.signedContext)
        setCurrentContextToken(event.data?.ctx)
      }
    }
  }

  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      window.addEventListener("message", receiveMessage, false)
      window.parent.postMessage("iframeFinishLoading", "*")
    }
    return () => {
      window.removeEventListener("message", receiveMessage, false)
    }
  }, [])

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSortDropdown && !event.target.closest(".sort-button-container")) {
        setShowSortDropdown(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [showSortDropdown])

  useUpdateInboxHeader({ title: "Send an invition to join the group", isGroupsView: true })

  const handleCopyInviteLink = () => {
    if (groupInviteLink) {
      navigator.clipboard.writeText(groupInviteLink)
      setCopyTooltipVisible(true)
      // Hide tooltip after 2 seconds
      setTimeout(() => {
        setCopyTooltipVisible(false)
      }, 2000)
    }
  }

  const handleInviteLinkClick = () => {
    if (groupInviteLink) {
      navigator.clipboard.writeText(groupInviteLink)
      setTooltipVisible(true)
      // Hide tooltip after 2 seconds
      setTimeout(() => {
        setTooltipVisible(false)
      }, 2000)
    }
  }

  const handleOpenMessageTemplate = () => {
    const currentSelectedContactsData = getSelectedContactsData()
    // Send message to parent window with static section id
    if (window.parent !== window) {
      window.parent.postMessage({
        type: "OPEN_INTEGRATION_MODAL",
        payload: {
          sectionId: "inbox_message_template",
          selectedContacts: currentSelectedContactsData,
          groupInviteLink,
          context: "group-invitation",
          isGroupInvitation: true,
        },
      }, "*")
    } else {
      console.warn("Parent window not found")
    }
  }

  const handleSendInviteViaMessage = () => {
    const currentSelectedContactsData = getSelectedContactsData()
    if (window.parent !== window) {
      window.parent.postMessage({
        type: "OPEN_INTEGRATION_MODAL",
        payload: {
          sectionId: "send-invite-via-message",
          selectedContacts: currentSelectedContactsData,
          groupInviteLink,
          context: "group-invitation",
          isGroupInvitation: true,
        },
      }, "*")
    } else {
      console.warn("Parent window not found")
    }
  }

  return (
    <FormContainer>
      <ModalBody style={{
        padding: 0,
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
      }}
      >
        <MarginWrapper style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
        }}
        >
          <SearchSection>
            <ContactsHeader>
              <ContactsCount>
                Select up to 8 contacts
                {selectedContacts.length > 0 && `(${selectedContacts.length}/8)`}
              </ContactsCount>
            </ContactsHeader>
            <SearchContainer>
              <SearchIcon icon={faSearch} />
              <SearchInput
                type="text"
                placeholder="Search name or phone number"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {searchQuery && (
                <ClearSearchButton onClick={() => setSearchQuery("")}>
                  <FontAwesomeIcon icon={faTimes} />
                </ClearSearchButton>
              )}
            </SearchContainer>
            {/* Selected Contacts Section */}
            <SelectedContactsSection>
              <SelectedContactsHeader>
                {selectedContacts.length > 0 ? `${selectedContacts.length}/8 selected` : "No contacts selected"}
              </SelectedContactsHeader>
              <SelectedContactsContainer>
                {selectedContacts.length === 0 ? (
                  <NoSelectionText>Select contacts from the list below</NoSelectionText>
                ) : (
                  selectedContactsData
                    .filter((contact) => selectedContacts.includes(contact.id))
                    .map((contact) => (
                      <SelectedContactTag key={contact.id}>
                        <SelectedContactName title={contact.name}>
                          {contact.name}
                        </SelectedContactName>
                        <RemoveContactButton
                          onClick={(e) => {
                            e.stopPropagation()
                            handleRemoveContact(contact.id)
                          }}
                        >
                          <FontAwesomeIcon icon={faTimes} />
                        </RemoveContactButton>
                      </SelectedContactTag>
                    ))
                )}
              </SelectedContactsContainer>
              {showLimitError && (
                <LimitErrorText>
                  ⚠️ Maximum 8 contacts allowed. Please remove a contact to add new ones.
                </LimitErrorText>
              )}
            </SelectedContactsSection>
            <div className="sort-button-container" style={{ position: "relative" }}>
              <SortButton onClick={handleSortToggle}>
                <FontAwesomeIcon icon={faArrowDownShortWide} fontSize="16px" color={theme.primary} />
                {getCurrentSortLabel()}
              </SortButton>
              {showSortDropdown && (
                <SortDropdown>
                  {sortOptions.map((option) => (
                    <SortOption
                      key={option.value}
                      selected={sortOrder === option.value}
                      onClick={() => handleSortChange(option.value)}
                    >
                      <span>{option.label}</span>
                      <RadioButton checked={sortOrder === option.value} />
                    </SortOption>
                  ))}
                </SortDropdown>
              )}
            </div>
          </SearchSection>
          <div style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
          }}
          >
            <ContactsList style={{
              flex: 1,
              overflow: "auto",
              minHeight: 0,
            }}
            >
              {loading && contacts.length === 0 && (
                <>
                  {renderSkeletonItems(6)}
                </>
              )}
              {!loading && sortedContacts.length === 0 && searchQuery && isPhoneNumber(searchQuery) && (
                <AddContactButton
                  onClick={() => addPhoneAsContact(searchQuery)}
                  style={{
                    opacity: selectedContacts.length >= 8 ? 0.5 : 1,
                    cursor: selectedContacts.length >= 8 ? "not-allowed" : "pointer",
                  }}
                  disabled={selectedContacts.length >= 8}
                >
                  <AddContactInfo>
                    <AddContactIcon>
                      <FontAwesomeIcon icon={faPlus} />
                    </AddContactIcon>
                    <AddContactText>
                      <AddContactLabel>
                        {selectedContacts.length >= 8 ? "Cannot add more contacts (8/8 limit reached)" : `Add "${searchQuery}"`}
                      </AddContactLabel>
                      <AddContactSubtext>
                        {selectedContacts.length >= 8 ? "Remove a contact to add new ones" : "Add this phone number as a new contact"}
                      </AddContactSubtext>
                    </AddContactText>
                  </AddContactInfo>
                </AddContactButton>
              )}
              {!loading && sortedContacts.length === 0 && (!searchQuery || !isPhoneNumber(searchQuery)) && (
                <ContactItem style={{ justifyContent: "center", cursor: "default" }}>
                  <span style={{ color: theme.gray6 }}>No contacts found</span>
                </ContactItem>
              )}
              {sortedContacts.length > 0 && (
                <>
                  {searchQuery && isPhoneNumber(searchQuery) && !sortedContacts.some((contact) => contact.phone === searchQuery || contact.id === searchQuery) && (
                    <AddContactButton
                      onClick={() => addPhoneAsContact(searchQuery)}
                      style={{
                        opacity: selectedContacts.length >= 8 ? 0.5 : 1,
                        cursor: selectedContacts.length >= 8 ? "not-allowed" : "pointer",
                      }}
                      disabled={selectedContacts.length >= 8}
                    >
                      <AddContactInfo>
                        <AddContactIcon>
                          <FontAwesomeIcon icon={faPlus} />
                        </AddContactIcon>
                        <AddContactText>
                          <AddContactLabel>
                            {selectedContacts.length >= 8 ? "Cannot add more contacts (8/8 limit reached)" : `Add "${searchQuery}"`}
                          </AddContactLabel>
                          <AddContactSubtext>
                            {selectedContacts.length >= 8 ? "Remove a contact to add new ones" : "Add this phone number as a new contact"}
                          </AddContactSubtext>
                        </AddContactText>
                      </AddContactInfo>
                    </AddContactButton>
                  )}
                  {sortedContacts.map((contact) => (
                    <ContactItem
                      key={contact.id}
                      selected={selectedContacts.includes(contact.id)}
                      onClick={() => handleContactToggle(contact.id)}
                    >
                      <ContactInfo>
                        {/* <ContactAvatar>
                          {contact.avatar ? (
                            <img src={contact.avatar} alt={contact.name} style={{ width: "100%", height: "100%", borderRadius: "50%" }} />
                          ) : (getInitials(contact.name)
                          )}
                        </ContactAvatar> */}
                        <ContactDetails>
                          <ContactName>{contact.name}</ContactName>
                          <ContactPhone>{contact.phone}</ContactPhone>
                        </ContactDetails>
                      </ContactInfo>
                      <Checkbox
                        type="checkbox"
                        checked={selectedContacts.includes(contact.id)}
                        onChange={(e) => {
                          e.stopPropagation() // Prevent event bubbling to parent ContactItem
                          handleContactToggle(contact.id)
                        }}
                        onClick={(e) => e.stopPropagation()} // Also prevent click event bubbling
                        disabled={!selectedContacts.includes(contact.id) && selectedContacts.length >= 8}
                      />
                    </ContactItem>
                  ))}
                  {pageInfo.hasNextPage && (
                    <LoadMoreButton
                      onClick={loadMoreContacts}
                      disabled={loading}
                    >
                      {loading ? "Loading..." : "Load More"}
                    </LoadMoreButton>
                  )}
                </>
              )}
            </ContactsList>
            <InviteLinkSection>
              <InviteLinkTitle>
                Copy this link
                <CopyButton onClick={handleCopyInviteLink} style={{ position: "relative" }}>
                  <FontAwesomeIcon icon={faLink} />
                  <Tooltip visible={copyTooltipVisible}>Copied!</Tooltip>
                </CopyButton>
              </InviteLinkTitle>
              <InviteLinkNote>
                You will need to paste it into the &quot;variables&quot; field of your message:
                {" "}
                <InviteLinkText
                  onClick={handleInviteLinkClick}
                  style={{ cursor: groupInviteLink ? "pointer" : "default", position: "relative" }}
                >
                  {groupInviteLink || "Link not available"}
                  <Tooltip visible={tooltipVisible}>Copied!</Tooltip>
                </InviteLinkText>
              </InviteLinkNote>
            </InviteLinkSection>
          </div>
        </MarginWrapper>
        {/* Action buttons styled like AddMemberModal */}
        <ActionButtonsContainer>
          <StyledActionButton
            primary
            onClick={() => handleOpenMessageTemplate()}
            // if not contact selected then make the button disabled
            disabled={selectedContacts.length === 0}
          >
            Send invite via template
          </StyledActionButton>
          {/* <StyledActionButton
            secondary
            onClick={() => handleSendInviteViaMessage()}
            // if not contact selected then make the button disabled
            disabled={selectedContacts.length === 0}
          >
            Send invite via message
          </StyledActionButton> */}
        </ActionButtonsContainer>
      </ModalBody>
    </FormContainer>
  )
}
export default AddMembers
